import type Immutable from 'immutable';

import type { LanguageEnum, LanguageLocalesEnum, SupportedLanguages } from 'js/src/client';
import type { ImmutableMap } from 'js/src/libs/consts';

export function convertLocaleToLanguageCode(
    supportedLanguages: Immutable.List<ImmutableMap<SupportedLanguages>>,
    localeOrLang: LanguageEnum | LanguageLocalesEnum,
): LanguageEnum | undefined {
    for (let i = 0; i < supportedLanguages.size; i++) {
        const lang = supportedLanguages.get(i);
        if (!lang) {
            continue;
        }
        if (lang.get('code') === localeOrLang) {
            return lang.get('code');
        }
        const translationLocales = lang.get('translation_locales');
        if (!translationLocales || translationLocales.size === 0) {
            continue;
        }
        for (let j = 0; j < translationLocales.size; j++) {
            const locale = translationLocales.get(j);
            if (locale && locale.get('code') === localeOrLang) {
                return lang.get('code');
            }
        }
    }
}
